import React from 'react';
import moment from 'moment/min/moment-with-locales';

export enum DIR {
    LTR = 'ltr',
    RTL = 'rtl'
}

import { getLocale } from '../utils/local.utils';

interface UseLocaleReturn {
    dir: DIR;
}

export const useLocale = (): UseLocaleReturn => {
    const locale = getLocale();
    const isRtl = locale === 'ar';
    const dir = isRtl ? DIR.RTL : DIR.LTR;
    React.useLayoutEffect(() => {
        if (!document.body.getAttribute('dir')) {
            moment.locale(locale);
            document.body.setAttribute('dir', dir);
        }
    }, [isRtl]);
    return { dir };
};
